import initialStore from './initialState'
import { IntegrationAction } from '../airbnb/actionNames'

export default function(
  store: Readonly<IIntegrationStore> = initialStore,
  action: any,
): IIntegrationStore {
  switch (action.type) {
    case IntegrationAction.SetIcalSettings:
      return {
        ...store,
        settings: action.payload.items,
        saving: false,
      }
    case IntegrationAction.SetIcalSaving:
      return {
        ...store,
        saving: action.payload,
      }
  }

  return store
}

export interface IIntegrationStore {
  settings: any | null
  saving: boolean
}
